const initialstate = false

function meeting_start(state = initialstate, action) {
    switch (action.type) {
        case "set_meeting_start":
            return  action.payload 
        case "clear_set_meeting_start":
            return initialstate

        default:
            return state
    }
}

export default meeting_start;